<template>
  <div class="otb-error-message">
    <img
      src="../../assets/error-message-image.png"
      class="otb-error-message__image-container"
    />
    <div class="otb-error-message__text-container">
      <div>
        <h1 class="otb-error-message__header wb-type-heading-l">
          {{ title }}
        </h1>
        <div class="otb-error-message__copy wb-type-copy">
          <p class="wb-type-copy" v-if="!details" v-html="text"></p>
          <div v-else class="otb-error-message__accordion">
            <template>
              <wb-accordion prevent-mobile-flyout>
                <wb-accordion-item>
                  <wb-accordion-toggle>
                    {{ text }}
                  </wb-accordion-toggle>
                  <wb-accordion-section class="otb-accordion-top">
                    <wb-accordion-mobile-header>
                      {{ $t('errorMessage.close') }}
                    </wb-accordion-mobile-header>
                    <wb-accordion-content>
                      {{ details }}
                    </wb-accordion-content>
                  </wb-accordion-section>
                </wb-accordion-item>
              </wb-accordion>
            </template>
          </div>
        </div>
      </div>
      <a
        class="otb-error-message__cta wb-type-copy wb-link wb-link--standalone"
        @click="handleGoToHome"
      >
        <wb-icon
          class="otb-error-message__cta-icon"
          name="bds/chevron-right/24"
        ></wb-icon>
        {{ cta }}
      </a>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'otb-error-message',
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    details: {
      type: String,
      default: '',
    },
    cta: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const handleGoToHome = (e: Event): any => {
      e.preventDefault();
      emit('goToHome');
    };

    return {
      handleGoToHome,
    };
  },
});
</script>
<style lang="scss" src="./error-message.scss"></style>
